import config from 'config'
import graphql from 'api/graphql'
import { load } from 'recaptcha-v3'
import { oauthTokenSelector } from 'selectors/app'
import { doAuthenticateFromToken } from 'actions/auth'
import { doReloadTokenInfo } from 'ducks/tokens/actions'
import { getClickIdFromStorage } from 'ducks/affiliates/util'
import { basicFields as accountFields } from 'api/account'
import { signupFields as userFields } from 'ducks/currentUser/api'
import { ACTIVE_SIGNUP_VARIATION } from 'subapps/onboarding/constants'
import { selectQueryParams } from 'selectors/location'
import {
  getSignupAccountAttributes,
  getMarketingAttribution,
} from '../../utils'
import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE } from '../../types'
import { V6_COMPANY_PAGE, V6_VERIFICATION_PAGE } from '../pages'

function getReCaptchaToken() {
  return load(config.google_recaptcha_site_key).then(recaptcha =>
    recaptcha.execute('signup')
  )
}

export function doSaveAndRedirect({ emailInput, password, name }) {
  return (dispatch, getState) => {
    return getReCaptchaToken().then(reCaptchaToken => {
      const state = getState()
      const query = selectQueryParams(state)
      const token = oauthTokenSelector(state)

      const signup = {
        authenticity_token: 'TOKEN',
        recaptcha_token: reCaptchaToken,
        source: 'marketing',
        user: {
          account_attributes: {
            ...getSignupAccountAttributes({ query }),
            type: 'helpdesk',
            onboarding_version: 2,
            disable_demo_tickets: true,
          },
          consents: {
            marketing: true,
            privacy_and_terms: true,
          },
          marketing_attribution: getMarketingAttribution(),
          email: emailInput,
          password,
          name,
        },
        affiliate_click_id: getClickIdFromStorage(),
        utf8: '✓',
      }

      dispatch({
        type: SIGNUP_REQUEST,
        data: { signup },
      })

      const mutation = `
        mutation signupAccount(
          $input: SignupInput!
        ){
          signupAccount(
            input: $input
          ) {
            account {
              ${accountFields}
            }
            user {
              ${userFields}
            }
          }
        }
      `

      const variables = {
        input: signup,
      }

      return graphql(token, mutation, variables)
        .then(res => {
          const data = res.json.data
          const { account, user } = data.signupAccount

          dispatch({
            type: SIGNUP_SUCCESS,
            payload: { account, user: { ...user, role: 'owner' } },
          })
          dispatch(doAuthenticateFromToken(user.token, user.expiresAt))
          dispatch(doReloadTokenInfo())
          dispatch({
            type:
              ACTIVE_SIGNUP_VARIATION === 'short'
                ? V6_VERIFICATION_PAGE
                : V6_COMPANY_PAGE,
          })
        })
        .catch(err => {
          dispatch({
            type: SIGNUP_FAILURE,
            payload: { error: err },
          })
        })
    })
  }
}
